/* Above Category — form state. Marks fields touched on blur (so :invalid can show without red), and fills the
   submit button (ac-btn--solid) once the form reports valid. Covers every form on the page, including ones
   Horizon renders later into drawers. Styles: assets/ac-ui.css, sections 6 and 7. */
(function () {
  var SUBMIT = 'button[type="submit"], button:not([type]), input[type="submit"]';
  function sync(form) {
    var valid = form.checkValidity();
    form.classList.toggle('ac-form--valid', valid);
    form.querySelectorAll(SUBMIT).forEach(function (b) {
      if (b.classList.contains('ac-btn')) b.classList.toggle('ac-btn--solid', valid);
    });
  }
  function bind(form) {
    if (form.dataset.acForms) return;
    form.dataset.acForms = '1';
    form.addEventListener('input', function () { sync(form); });
    form.addEventListener('change', function () { sync(form); });
    form.addEventListener('focusout', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input, textarea, select')) { t.classList.add('ac-touched'); form.classList.add('ac-touched'); }
    });
    form.addEventListener('submit', function () { form.classList.add('ac-touched'); });
    sync(form);
  }
  function scan(root) { (root || document).querySelectorAll('form').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'FORM') bind(n); else scan(n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
